import { takeLatest, call, put } from 'redux-saga/effects';
import { EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_PAGE_REQUEST } from 'actions/example/form/dropdownCalendarForm/constants';
import { initialize } from 'redux-form';
import moment from 'moment';
import { getFilteredDate } from 'api/get-filtered-date';

export function* pageRequest() {
  const { data } = yield call(getFilteredDate);
  const form = {
    date: {
      startDate: moment(data.start_date, 'YYYY-MM-DD'),
      endDate: moment(data.end_date, 'YYYY-MM-DD'),
    },
  };
  yield put(initialize('dropdownCalendar', form));
}

export default function* saga() {
  yield takeLatest(
    EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_PAGE_REQUEST,
    pageRequest
  );
}
